export default {
      id: "icon-star-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }